export default function PrimaryOutlineButton({ className = '', disabled, children, ...props }) {
    return (
        <button
            {...props}
            className={
                `cursor-pointer inline-flex items-center px-4 py-2 border border-white rounded-md font-semibold text-xs text-white hover:text-blue-900 uppercase tracking-widest hover:bg-white focus:text-blue-900 focus:bg-white active:text-blue-900 active:bg-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 transition ease-in-out duration-150 ${
                    disabled && 'opacity-25'
                } ` + className
            }
            disabled={disabled}
        >
            {children}
        </button>
    );
}
